import { render, staticRenderFns } from "./ModalMessage.vue?vue&type=template&id=7d5f10f6&scoped=true"
import script from "./ModalMessage.vue?vue&type=script&lang=js"
export * from "./ModalMessage.vue?vue&type=script&lang=js"
import style0 from "./ModalMessage.vue?vue&type=style&index=0&id=7d5f10f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5f10f6",
  null
  
)

export default component.exports